import { Controller } from "@hotwired/stimulus"

// Reveals [data-reveal] descendants (or the element itself) as they enter
// the viewport, staggering siblings through --reveal-delay. The hidden
// initial state only applies under html.js (application.tailwind.css), so
// content stays visible without JavaScript.
export default class extends Controller {
  static values = { stagger: { type: Number, default: 90 } }

  connect() {
    const items = this.element.matches("[data-reveal]")
      ? [this.element]
      : Array.from(this.element.querySelectorAll("[data-reveal]"))

    items.forEach((item, index) => {
      item.style.setProperty("--reveal-delay", `${index * this.staggerValue}ms`)
    })

    if (!("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("is-revealed"))
      return
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          entry.target.classList.add("is-revealed")
          this.observer.unobserve(entry.target)
        }
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    )

    items.forEach((item) => this.observer.observe(item))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
